import React from 'react';
import {Link} from 'react-router-dom';

import Authenticated from 'Components/Layouts/Authenticated';
import {Loading} from 'Components/Partials';
import SocketIndicator from 'Components/Utilities/SocketIndicator';

import User from 'Services/User';
import {translation} from 'Services/TranslationHelpers';

import Base from './Base';
import { asset } from "Services/BaseHelpers";
import MainstageQuestionsStandAlone from "Components/MainStage/MainStageQuestionsStandAlone";

export default class MainStageQuestions extends Base {
    /**
     * @var success
     * @type {boolean}
     */
    remote_control = false;

    /**
     * @var state
     */
    state = {
        working: false,
        sessions: null,
        currentSession: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.mountBase();
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        this.unmountBase();
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {working, currentSession} = this.state;

        return (
            <div className={'bg-questions bg-cover bg-no-repeat h-screen overflow-y-auto w-full'}>
                <div className=" w-full flex justify-center items-center pt-36 md:pt-0">
                    <img
                        src={ asset ( '/images/box-text.png' ) }
                        alt="logo"
                        className="h-60"
                    />
                </div>

                <div className="p-4 md:px-0 pt-20 md:pt-0 lg:px-16 mx-auto pb-8 px-4 relative z-10">
                    {working && (<Loading/>)}

                    {!working && (
                        <React.Fragment>
                            {!currentSession &&
                                <div className="bg-main-stage-comments overflow-hidden rounded-xl sm:shadow w-full py-5 text-white text-center">
                                    {translation('main_stage_frontend', 'no_sessions_live_come_back_later')}
                                </div>
                            }

                            {currentSession && (
                                <div>
                                    <div className="flex max-w-7xl mx-auto">
                                        {this.renderQuestion()}
                                    </div>
                                </div>
                            )}
                        </React.Fragment>
                    )}
                </div>
            </div>
        );
    }

    /**
     * @method renderQuestion
     * @return {JSX.Element}
     */
    renderQuestion = () => (
        <MainstageQuestionsStandAlone
            heightRestriction={false}
            readOnly={true} sessionId={this.state.currentSession.id} />
    );
}
